import React, { useCallback, useState } from 'react';

import { DuplicateSourceError } from './DuplicateSourceError';
import { isDuplicateSourceUrl } from './sourceUrlComparison';

type SourceWithUrl = {
	url?: string | null;
};

type SubmitIfUniqueSource = (
	url: string,
	sources: readonly SourceWithUrl[],
	onUniqueSource: () => void,
) => void;

export const useDuplicateSourceGuard = (): {
	duplicateSourceFooterError: React.ReactNode;
	resetDuplicateSourceError: () => void;
	submitIfUniqueSource: SubmitIfUniqueSource;
} => {
	const [isDuplicateError, setIsDuplicateError] = useState(false);

	const resetDuplicateSourceError = useCallback(() => {
		setIsDuplicateError(false);
	}, []);

	const submitIfUniqueSource = useCallback<SubmitIfUniqueSource>((url, sources, onUniqueSource) => {
		if (isDuplicateSourceUrl(url, sources)) {
			setIsDuplicateError(true);
			return;
		}

		setIsDuplicateError(false);
		onUniqueSource();
	}, []);

	return {
		duplicateSourceFooterError: isDuplicateError ? <DuplicateSourceError /> : undefined,
		resetDuplicateSourceError,
		submitIfUniqueSource,
	};
};
